import LegacyPresentationBuilder from '../../pages/builder/LegacyPresentationBuilder';
import CreateSlideDeck from '../../pages/slide_builder/CreateSlideDeck.vue';
import {authGuard} from '../guards';
import store from '../../store';
import SlideDecks from '../../pages/slide_builder/SlideDecks.vue';

function getRoutes(routePrefix, layout) {

  const basePath = routePrefix === 'library'
    ? '/v2/app/content'
    : '/v2/mobile';

  return [
    {
      path: `${basePath}/slide-decks`,
      name: `${routePrefix}.slide_decks`,
      component: SlideDecks,
      meta: {
        layout: layout,
        title: `Slide Decks`,
        allow_restricted_user: false, // MLD-2750
        gate: () => {
          return store.getters.canUseBuilder;
        }
      },
    },
    { // MLD-6435
      path: `${basePath}/presentation-builder`,
      name: `${routePrefix}.slide_deck.create`,
      component: CreateSlideDeck,
      meta: {
        layout: layout,
        title: `New Slide Deck`,
        allow_restricted_user: false, // MLD-2750
        gate: () => {
          return store.getters.canUseBuilder;
        }
      },
    },
    { // MLD-2729
      path: `${basePath}/legacy-presentation-builder`,
      name: `${routePrefix}.legacy.presentation.builder`,
      component: LegacyPresentationBuilder,
      meta: {
        layout: layout,
        title: `Legacy Presentation Builder`,
        allow_restricted_user: false, // MLD-2750
        gate: () => {
          return store.getters.canUseBuilder;
        }
      },
    },
  ]
}

export default [
  ...authGuard([
    ...getRoutes('library', 'content'),
    ...getRoutes('mobile', 'mobile'),
  ]),
]
